module.exports = __webpack_public_path__ + "static/media/logo IPA.ea782e48.png";